<template>
  <div>
    <b-button @click="showAutoNreModal()" style="width: 9.5rem" variant="primary">Automate NRE</b-button>
    <b-modal centered ok-title="Confirmed and Submit"
             @ok="autoApprovePreConfirm"
             ref="AutoPassModal"
             title="Control Panel: Automate NRE Estimation & Approval"
             no-close-on-backdrop
             button-size="sm">

      <div v-if="control_panel_warning !== null">
        <b-alert show variant="warning">{{control_panel_warning}}</b-alert>
      </div>

      <div class="header-col pb-2">
        <div>
          <b>Remark</b><span class="text-danger pl-1">*</span>
        </div>
        <div class="flex-fill">
          <div class="flex-wrap">
            <div class="w-100">
              <b-badge variant="light">Text area is editable</b-badge>
              <textarea class="w-100" v-model="espmRemark"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="header-col pb-2">
        <div><b>Module</b><span class="text-danger pl-1">*</span></div>
        <div class="flex-fill">
          <div class="flex-wrap">
            <div class="w-100">
              <b-badge variant="light">Text area is editable</b-badge>
              <textarea class="w-100" v-model="espmEstimationModule"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="header-col pb-2">
        <div><b>Reference SKU ID</b><span class="text-danger pl-1">*</span></div>
        <div class="flex-fill">
          <div class="flex-wrap">
            <div class="w-100">
              <b-form-select v-model="refSkuTmp"
                             :options="standardSkuList"
                             @change="getSkuPriceInfo()">

              </b-form-select>
            </div>
          </div>
        </div>
      </div>

      <div class="header-col pb-2 border-bottom pb-4">
        <div><b>Currency</b><span class="text-danger pl-1">*</span></div>
        <div class="flex-fill">
          <div class="flex-wrap">
            <div class="w-100">
              <b-form-select v-model="currencyTmp"
                             :options="currencyOptions"
                             @change="getSkuPriceInfo()">

              </b-form-select>
            </div>
          </div>
        </div>
      </div>

      <div class="header-col pb-2">
        <b>SKU Information</b><span class="text-danger pl-1">*</span>
      </div>
      <div v-if="checkActionEnable()">
        <b-button @click="getSkuPriceInfo()" size="sm" variant="primary">Get eQuote SKU Info </b-button>
      </div>
      <div class="row mb-4">
        <div class="col-12">
          <div class="row">
            <div class="col-auto">
              <div class="header-col">
                <div>Standard SKU ID</div>
                <div v-if="autoNreSkuObj.state ==false && autoNreSkuObj.price_info">
                  {{ estimatedRefSku }}
                </div>
                <div v-else>
                  {{ estimatedRefSku }}
                  <span v-if="alreadyHitDecodeButton === true"
                        class="text-danger">Fail to get SKU info from eQuote.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex">
            <div style="min-width: 7.5rem ">HQ Cost</div>
            <div class="ml-2" v-if="autoNreSkuObj !== null && _.get(autoNreSkuObj, 'price_info', null)!== null">
              {{ currencySign}} {{ _.get(autoNreSkuObj, 'price_info.hq_cost', '') | comma }}
            </div>
          </div>
          <div class="d-flex">
            <div style="min-width: 7.5rem ">GRO Cost</div>
            <div class="ml-2"
                 v-if="autoNreSkuObj !== null && _.get(autoNreSkuObj, 'price_info', null)!== null">{{currencySign}} {{ _.get(autoNreSkuObj, 'price_info.gro_cost', '') | comma }}</div>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex">
            <div style="min-width : 7.5rem">Distributor Price</div>
            <div class="ml-2"
                 v-if="autoNreSkuObj !== null && _.get(autoNreSkuObj, 'price_info', null)!== null">{{currencySign}} {{ _.get(autoNreSkuObj, 'price_info.distributor_price', '') | comma }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 7.5rem">Reseller Price</div>
            <div class="ml-2"
                 v-if="autoNreSkuObj !== null && _.get(autoNreSkuObj, 'price_info', null)!== null">{{currencySign}} {{ _.get(autoNreSkuObj, 'price_info.reseller_price', '') | comma }}</div>
          </div>
          <div class="d-flex">
            <div style="min-width: 7.5rem">MSRP</div>
            <div class="ml-2"
                 v-if="autoNreSkuObj !== null && _.get(autoNreSkuObj, 'price_info', null)!== null">{{currencySign}} {{ _.get(autoNreSkuObj, 'price_info.msrp', '') | comma }}</div>
          </div>
        </div>

        <div class="col-12 mb-4"
             v-if="autoNreSkuObj !== null && (_.get(autoNreSkuObj,'price_info.eol',false) || (_.get(autoNreSkuObj,'remark','') !== '' && _.get(autoNreSkuObj,'remark','') !== null))">
          <div class="row">
            <div class="col-auto">
              <b-alert show variant="danger" class="d-flex align-items-start gap-2 py-2 px-3">
                <span style="font-size:1.1em; line-height:1.5; flex-shrink:0;">&#9888;</span>
                <div>
                  <div v-if="_.get(autoNreSkuObj,'price_info.eol',false)"><strong>This SKU ID has been EOL!</strong></div>
                  <div v-if="_.get(autoNreSkuObj,'remark','') !== '' && _.get(autoNreSkuObj,'remark','') !== null">
                    <strong>Remark:</strong> {{_.get(autoNreSkuObj,'remark','')}}
                  </div>
                </div>
              </b-alert>
            </div>
          </div>
        </div>

        <div v-if="autoNreSkuObj.description" class="col-12">
          Standard SKU Description
        </div>
        <div class="col-12 mb-4">
          <div v-if="autoNreSkuObj.description"><b-form-textarea v-model="autoNreSkuObj.description" disabled no-resize max-rows="10"></b-form-textarea></div>
        </div>
        <div v-if="customSkuDesc" class="col-12">
          <div> <b>Custom SKU Description</b><span class="text-danger pl-1">*</span></div>
        </div>
        <div v-if="customSkuDesc" class="col-12">
          <div>
            <b-badge variant="light">Text area is editable</b-badge>
            <b-form-textarea v-model="customSkuDesc" rows="5" max-rows="10"></b-form-textarea>
          </div>
        </div>
      </div>

    </b-modal>
    <b-modal centered :ok-title="autoApproveObj.okTitle" @ok="autoPassNre"
             :cancel-title="autoApproveObj.cancelTitle"
             :ok-variant="autoApproveObj.variant"
             :title-class="[`text-${autoApproveObj.variant || 'primary'}`]"
             ref="AutoApproveConfirmModal" :title="autoApproveObj.title"
             button-size="sm">
      <div>
        <p><b>{{ autoApproveObj.message1 }}</b></p>
        <p>{{ autoApproveObj.message2 }}</p>
      </div>
      </br>
      <div>{{ autoApproveObj.message2_2 }}</div>

    </b-modal>
    <b-modal centered
             :cancel-title="autoApproveObj.cancelTitle"
             :ok-variant="autoApproveObj.variant"
             :title-class="[`text-${autoApproveObj.variant || 'primary'}`]"
             ref="AutoApproveAlert" :title="autoApproveObj.message3"
             button-size="sm">

      <div>{{ autoApproveObj.message4 }}</div>
    </b-modal>

    <b-modal centered
             :cancel-title="autoApproveObj.cancelTitle"
             :ok-variant="autoApproveObj.variant"
             :title-class="[`text-${autoApproveObj.variant || 'primary'}`]"
             ref="AutomationSuccessInfo" :title="autoApproveObj.title"
             button-size="sm">
      <div>
        <p><b>{{ autoApproveObj.messageSuccessHeader }}</b></p>
        <p>{{ autoApproveObj.messageSuccess }}</p>
  <a class="link"v-if="prop_ftie_id" target="_blank" :href="safeUrl(`${ frontEndUrl }/dashboard/${prop_ftie_id}`)">NRE Records for {{prop_ftie_id}}</a>
      </div>
    </b-modal>

    <b-modal centered
             :cancel-title="autoApproveObj.cancelTitle"
             :ok-variant="autoApproveObj.variant"
             :title-class="[`text-${autoApproveObj.variant || 'primary'}`]"
             ref="AutomationErrInfo" :title="autoApproveObj.title"
             button-size="sm">
      <div>
        <p><b>{{ autoApproveObj.messageErrorHeader }}</b></p>
        <p>{{ autoApproveObj.messageError }}</p>
      </div>
    </b-modal>

    <!--#endregion "-->
  </div>
</template>

<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'auto-nre-trigger', // AutoNreTrigger
    /*autopilot- sku*/
    props: {
      prop_sfdcProducts: {
        default: []
      },
      prop_user: {
        default: null
      },
      prop_ftie_id: {
        default: null
      },
      prop_detail_id: {
        default: null
      },
      prop_model_name: {
        default: null
      },
      prop_site:{
        default: null
      },
      prop_es_info: {
        default: null
      },

    },
    data: function () {
      return {
        frontEndUrl: null,
        login_user_name: null,
        userFunctions: null,
        userRoles: null,
        userSites: null,
        skuPnListForNre: null,
        skuPnListForNreFields: [
          { key: 'real_sku_no', label: 'SKU#', thClass: 'align-middle', sortable: true },
          { key: 'custom_sku_id', label: 'Customization SKU ID', thClass: 'align-middle', sortable: true },
          { key: 'standard_sku_id', label: 'Standard SKU ID', thClass: 'align-middle', sortable: true },
          {
            key: 'standard_sku_desc', label: 'SKU Description',
            thClass: 'align-middle', thStyle: { width: "35%" },
            sortable: true
          },
          {
            key: 'product_family', label: 'Product Family',
            thClass: 'align-middle',
            sortable: true
          },
          {
            key: 'nre_quotes', label: 'NRE Quote', thClass: 'align-middle',
            sortable: true, sortByFormatted: true,
            formatter: (value, key, item) => {
              return item.nre_quotes_cnt;
            }
          },
          {
            key: 'customization_pn_set', label: 'Standard P/N Maintain in SFDC', thClass: 'align-middle',
            tdClass: 'min-w-187',
            thStyle: { width: "20%" },
            sortable: true
          },
          {
            key: 'create_date', label: 'Create Date',
            thClass: 'align-middle', thStyle: { width: "10%" },
            sortable: true
          },
        ],
        refSkuListFields: [
          { key: 'chosen', label: '', thClass: 'align-middle', sortable: false },
          { key: 'model_name', label: 'Model', thClass: 'align-middle', sortable: true },//model_name
          { key: 'standard_sku_id', label: 'Reference SKU ID', thClass: 'align-middle', sortable: true },
          {
            key: 'standard_sku_desc', label: 'SKU Description',
            thClass: 'align-middle', thStyle: { width: "65%" },
            sortable: true
          },
        ],
        autoNreSkuObj: { skuId: null, state: false, errMsg: null, price_info: null },
        currencyRates: {
          "GUSA(USD)": 1,
          "WW (USD)": 1,
          "EU (GBP)": null,
          "EU (EUR)": null,
          "EU (AUD)": null,
          "GML (CNY)": null,
        },
        currencyOptions: [
          { value: "GUSA(USD)", text: "GUSA(USD)" },
          { value: "WW (USD)", text: "WW (USD)" },
          { value: "EU (GBP)", text: "EU (GBP)" },
          { value: "EU (EUR)", text: "EU (EUR)" },
          { value: "EU (AUD)", text: "EU (AUD)" },
          { value: "GML (CNY)", text: "GML (CNY)" },

        ],
        currencySigns: {
          "GUSA(USD)": '$',
          "WW (USD)": '$',
          "EU (GBP)": '£',
          "EU (EUR)": '€',
          "EU (AUD)": '$',
          "GML (CNY)": '¥'
        },
        currencyTmp: null,
        refSkuTmp: null,
        estimatedCurrency: null,
        estimatedRefSku: null,
        customSkuDesc: null,
        sfCurrency: null,
        autopilot_required_info: null,
        autopilot_flag_confirm_by_espm: null,
        autopilot_flag_by_sa: null,
        control_panel_warning: null,
        espmRemark: null,
        espmEstimationModule: null,
        alreadyHitDecodeButton: false,
        autoApproveObj:{
          title: 'NRE Automation',
          titleClass: null,
          size: null,
          buttonSize: null,
          okVariant: null,
          okTitle: 'Yes, Automate the NRE',
          cancelTitle: 'Cancel',

          action: 'auto_approve',
          message1: 'Are you sure want to trigger this NRE Automation?',
          message2: 'This process will bypass all GTC and GRO NRE approval stages, immediately making the ETO Quote available in eQuote and automatically completing the project kick-off.',
          message2_2: '**Confirm you understand these consequences before proceeding.**',
          message3: 'Missing Mandatory Fields',
          message4: 'Cost empty!! Please ensure that you choose the correct sku and hit the Get eQuote SKU Info button!',
          messageSuccessHeader: 'Automation process completed successfully! ',
          messageErrorHeader: 'Automation process failed! ',
          messageSuccess: 'You can review the details on the NRE Dashboard.',
          messageError: 'Please reach out to System Adminstrators with screnshot and necessary info for the trouble shooting!',

          reason: 'auto approve',
          state: false,
          variant: 'primary',
          invalidFeedback: 'Please contact system admin for this error.'
        }
      }
    },

    computed: {
      standardSkuList() {
        let self = this;
        let tempList = _.uniq(_.map(self.prop_sfdcProducts, (product) => product.standard_sku_id));

        return _.filter(tempList, item => { return item!=null; });
      },
      currencySign() {
        let self = this
        return self.currencySigns[self.estimatedCurrency];
      }
    },

    created() {
      let self = this;
      self.frontEndUrl = self.$root.frontEndUrl;
      self.checkLoggedIn();
      self.checkActionEnable();
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        //var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');
        this.login_user_name = user_name
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
      },

      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        if (self.login_user_name === 'power') {
          return true;
        }

        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if ((self.userSites && _.indexOf(self.userSites, 'Getac') > -1)
            && (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1 || _.indexOf(self.userRoles, 'ES_PM') > -1))
          {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (self.userSites && _.indexOf(self.userSites, 'Getac') > -1
            && (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1))
          {
            return true;
          }
        }
        return false;
      },
      emptyModalInfo() {
        let self = this;
        self.alreadyHitDecodeButton = false;
        _.set(self.autoNreSkuObj, 'skuId', null);
        _.set(self.autoNreSkuObj, 'state', null);
        _.set(self.autoNreSkuObj, 'errMsg', null);
        _.set(self.autoNreSkuObj, 'price_info', null);
        _.set(self.autoNreSkuObj, 'description', null);
        _.set(self.autoNreSkuObj, 'remark', null);
        self.customSkuDesc = null;
        self.currencyTmp = null;
        self.refSkuTmp = null;
        self.estimatedCurrency = null;
        self.estimatedRefSku = null;
        self.sfCurrency = null;
        self.autopilot_required_info = null;
        self.autopilot_flag_confirm_by_espm = null;
        self.autopilot_flag_by_sa = null;
        self.espmEstimationModule = null;
        self.espmRemark = null;
        //self.control_panel_warning = null;
      },

      //#region -- Auto Nre sku id --
      showAutoNreModal() {
        let self = this;
        self.emptyModalInfo();
        // # check es_info primarily info matching_issue equal to 'Software - Autopilot'
        if (self.prop_es_info && _.get(self.prop_es_info, 'primary_info.matching_issue', null) === 'Software - Autopilot')
        {
          self.getSfCurrency();
          self.autoNreSkuObj = { skuId: null, state: false, errMsg: null, price_info: null, description: null, remark: null };
          self.checkAutopilotTenantInfo(self.prop_es_info);
          self.espmEstimationModule = 'MSFT Autopilot';
          self.espmRemark = 'Automated NRE for MSFT Autopilot';
          self.$refs['AutoPassModal'].show();

          /*
          if (self.prop_es_info.autopilot_info && self.prop_es_info.autopilot_info.admin_email_val && self.prop_es_info.autopilot_info.tenant_domain
            && self.prop_es_info.autopilot_info.tenant_id) {
            self.getSfCurrency();
            self.autoNreSkuObj = { skuId: null, state: false, errMsg: null, price_info: null, description: null };
            self.$refs['AutoPassModal'].show();
          } else {
            self.$message.warning('Please Confirm Autopilot Information has been entered by Level 1/GRO SA Before Proceed with AutoPass NRE.');
          }**/
        }
      },
      getSfCurrency() {
        let self = this;
        let urlFetch = `${self.$root.baseUrl}/nre/sf-currency/`;
        let requestData = {
          ftie_id: self.prop_ftie_id,
        };
        eventHub.$emit('loading', true);
        self.$axios
          .post(urlFetch, requestData)
          .then(resRead => {
            //console.log(resRead);
            if (_.get(resRead, 'status', 0) !== 200) return;
            let data = resRead.data;
            self.sfCurrency = data.sf_currency;
          })
          .finally(() => {
            if (self.sfCurrency) {
              if (self.sfCurrency == "USD") {
                if (self.prop_site == "GUSA") {
                  self.currencyTmp = "GUSA(USD)";
                } else {
                  self.currencyTmp = "WW (USD)";
                }
              } else {
                const result = _.find(self.currencyOptions, item => item.value.includes(self.sfCurrency))
                if (result) {
                  self.currencyTmp = result.value;
                }
              }

            }
            eventHub.$emit('loading', false);
          });
      },
      getSkuPriceInfo(bvModalEvt) {
        let self = this;
        if (self.checkActionEnable() === false) {
          self.$message.warning('You do not have the SKU decoder permission!', 'Access Required');
          return false;
        }
        if (self.refSkuTmp === null || '' === self.refSkuTmp) {
          self.$message.warning('Please select the reference SKU ID!', 'Empty SKU ID');
          return false;
        }
        let urlFetch = `${self.$root.baseUrl}/nre/autopilot-sku/`;
        let requestData = {
          username: self.prop_user,
          currency: self.currencyTmp,
          sku_id: self.refSkuTmp,
          model_name: self.prop_model_name,
          ftie_id: self.prop_ftie_id,
          detail_id: self.prop_detail_id,
        };
        self.estimatedRefSku = self.refSkuTmp;
        self.estimatedCurrency = self.currencyTmp;
        eventHub.$emit('loading', true);
        self.$axios
          .post(urlFetch, requestData)
          .then(resRead => {
            //console.log(resRead);
            if (_.get(resRead, 'status', 0) !== 200) {
              self.autoNreSkuObj = {
                skuId: null,
                state: true,
                errMsg: null,
                price_info: null,
                description: null,
                remark: null
              }
              self.customSkuDesc = null;
              self.estimatedRefSku = null;
              self.estimatedCurrency = null;
              self.$message.error('Failed to get SKU info from eQuote, please check if currency and SKU are correctly matched!', 'Cannot Find SKU Info');
              return;
            }
            else {
              let data = resRead.data;
              data.ref_sku_object = _.first(JSON.parse(data.ref_sku_object));
              data.autopilot_required_info = JSON.parse(data.autopilot_required_info);
              self.autopilot_required_info = data.autopilot_required_info;
              console.log(self.autopilot_required_info)
              //self.autopilot_flag_by_sa = data.autopilot_flag_by_sa
              //self.autopilot_flag_confirm_by_espm = data.autopilot_flag_confirm_by_espm
              if (data.ref_sku_object['price_info']['cost_empty'] === false) {
                //data.ref_sku_object['exchange_rate'] = `${self.currencyRate}:1`;
                self.autoNreSkuObj = {
                  skuId: data.ref_sku_object['sku_id'], state: false, errMsg: null,
                  price_info: data.ref_sku_object['price_info'],
                  description: data.ref_sku_object['description'],
                  remark: data.ref_sku_object['remark']
                }
                self.customSkuDesc = data.ref_sku_object['description'];
                if (self.customSkuDesc !== null || self.customSkuDesc !== '') {
                  self.customSkuDesc = self.customSkuDesc + '; Customization: Autopilot.'
                }
              } else {
                // if ((trigger === 'cancel' && self.substituteObj.state === true) || trigger === 'applyCurrencyChange') {
                data.ref_sku_object['exchange_rate'] = `${self.currencyRate}:1`;
                self.autoNreSkuObj = {
                  skuId: data.ref_sku_object['sku_id'],
                  state: true,
                  errMsg: "Can't find this sku info. Please try another one!",
                  price_info: null,
                  description: null,
                  remark: null
                }
                self.customSkuDesc = null;
                self.estimatedRefSku = null;
                self.estimatedCurrency = null;
                self.$message.error('Failed to get SKU info from eQuote, please check if currency and SKU are correctly matched!', 'Cannot Find SKU Info');
              }
            }
          })
          .finally(() => {
            self.alreadyHitDecodeButton = true;
            eventHub.$emit('loading', false);
          });
      },
      cancelModal(bvModalEvt) {
        let self = this;
        /*
        self.autoNreSkuObj = { skuId: null, state: false, errMsg: null, price_info: null };
        self.currencyTmp = null;
        self.refSkuTmp= null;
        self.estimatedCurrency = null;
        self.estimatedRefSku = null;
        self.customSkuDesc = null;
        self.sfCurrency = null;
        self.autopilot_required_info = null;
        self.autopilot_flag_confirm_by_espm = null;
        self.autopilot_flag_by_sa = null;

        */

        self.emptyModalInfo();        
        self.$nextTick(() => {
          self.$refs['AutoPassModal'].hide();
        });
      },
      //#endregion

      // # region: check autopilot information
      checkAutopilotTenantInfo(es_info) {
        let self = this;
        if (_.get(es_info, 'autopilot_info', null) === null
          || _.get(es_info, 'autopilot_info.admin_email_val', null) === null
          || _.get(es_info, 'autopilot_info.tenant_domain', null) === null
          || _.get(es_info, 'autopilot_info.tenant_id', null) === null
          || _.get(es_info, 'autopilot_info.admin_email_val', null) === ''
          || _.get(es_info, 'autopilot_info.tenant_domain', null) === ''
          || _.get(es_info, 'autopilot_info.tenant_id', null) === '')
        {
          self.control_panel_warning = 'Warning: NRE process can continue, but Autopilot Registration Info (Tenant ID, Domain, Admin Email) is missing. Please ask Ticket Raiser (SA) to update this information ASAP.';
          return false;
        }
        else {
          // self.control_panel_warning = 'Warning: NRE process can continue, but Autopilot Registration Info (Tenant ID, Domain, Admin Email) is missing. Please ask Ticket Raiser (SA) to update this information ASAP.';
          self.control_panel_warning = null;
          return true;
        }
      },
      // # end region
      autoApprovePreConfirm(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        if (!(self.autoNreSkuObj.state == false && self.autoNreSkuObj.price_info)) {
          self.$refs['AutoApproveAlert'].show();
        }
        else {
          // self.control_panel_warning = null;
          self.$refs['AutoApproveConfirmModal'].show();
        }
      },

      autoPassNre(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        self.$nextTick(() => {
          self.$refs['AutoApproveConfirmModal'].hide();
        })

        if (!(self.autoNreSkuObj.state == false && self.autoNreSkuObj.price_info)) {
          self.$message.warning('SKU cost empty!! Please ensure that you choose the correct SKU!', 'Empty SKU Cost');
          return false;
        }
        if (self.customSkuDesc === null || self.estimatedRefSku === null) {
          self.$message.warning('Missing SKU ID and Description! Please ensure that you choose the correct SKU!', 'Empty SKU');
          return false;
        }

        const text = self.estimatedCurrency;
        let currency = '';
        const match = text.match(/\((.{0,100}?)\)/);
        if (match) {
          currency = match[1];
        }
        let requestData = {
          ftie_id: self.prop_ftie_id,
          detail_id: self.prop_detail_id,
          autopilot_sku_id: self.estimatedRefSku,
          custom_sku_desc: self.customSkuDesc,
          currency: currency,
          equoteRegion: self.estimatedCurrency,
          sku_info: self.autoNreSkuObj,
          autopilot_required_info: self.autopilot_required_info,
          espm_remark: self.espmRemark,
          espm_estimation_module: self.espmEstimationModule,
        };
        let urlFetch = `${self.$root.baseUrl}/nre/autopilot-sku-nre/create/`;
        eventHub.$emit('loading', true);
        self.$axios
          .post(urlFetch, requestData)
          .then(resRead => {
            //console.log(resRead);
            if (_.get(resRead, 'status', 0) !== 200) return;
            let data = resRead.data;
            if (data.insert_success) {
              // self.$message.info('auto-nre success!');
              self.$refs['AutomationSuccessInfo'].show();
              
            } else {
              // AutomationErrInfo
              // self.$message.error('auto-nre failed!', 'Error');
              self.$refs['AutomationErrInfo'].show();
            }

          })
          .finally(() => {
            self.emptyModalInfo();
            eventHub.$emit('loading', false);
          });
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auto-nre/AutoNreTrigger.vue